import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { NotionRenderer } from 'react-notion';
import Grid from '@mui/material/Grid';
import Page from 'components/system/Page';
import useNotionData from 'hooks/useNotionData';
import Loading from 'components/system/Loading/Loading';
import Paper from 'components/system/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import colors from 'styles/colors';
import 'styles/notion.css';

const CompetitionNotion = React.memo(({ link }) => {
  const { data: competitionNotionData, loading, error } = useNotionData(link);

  // State to track initial render
  const [hasShownLoading, setHasShownLoading] = useState(false);

  // Determine if we should show loading state
  const shouldShowLoading = loading && isEmpty(competitionNotionData) && !hasShownLoading;

  // Mark loading as shown once it happens
  useEffect(() => {
    if (shouldShowLoading) {
      setHasShownLoading(true);
    }
  }, [shouldShowLoading]);

  if (error || error?.message) {
    return (
      <Page>
        <Paper>
          <Box
            sx={{
              display: 'flex',
              height: '30vh',
              width: '100%',
              textAlign: 'center',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box>
              <Typography variant="h5" color={colors.text.primary}>
                {`${(typeof error !== 'string' ? error?.message : error) || 'Something went wrong'}`}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Page>
    );
  }

  return (
    <Grid item xs={12}>
      {shouldShowLoading ? <Loading /> : (
        <>
          {!isEmpty(competitionNotionData) ? (
            <NotionRenderer blockMap={competitionNotionData} />
          ) : (
            <Box>
              <Typography variant="h6" color={colors.text.primary}>
                No data to show
              </Typography>
            </Box>
          )}
          <div />
        </>
      )}
    </Grid>
  );
}, (prevProps, nextProps) => prevProps.link === nextProps.link);

export default CompetitionNotion;
